import React from "react";
import { useStores } from "../stores";

const styles = {
  mutedText: { color: "#94A3B8" },
  link: {
    background: "none",
    border: "none",
    color: "#FFFFFF",
    opacity: 0.75,
    textDecoration: "none",
  },
  heading: { color: "#94A3B8" },
  border: { borderColor: "#334155" },
  whiteText: { color: "#FFFFFF" },
} as const;

const Footer: React.FC = () => {
  const { contactStore } = useStores();

  const handleSocialMediaClick = (
    media: "instagram" | "facebook" | "whatsapp",
  ) => {
    switch (media) {
      case "instagram":
        contactStore.openInstagram();
        break;
      case "facebook":
        contactStore.openFacebook();
        break;
      case "whatsapp":
        contactStore.openWhatsApp("Olá, vim pelo site Imóveis Mendicino");
        break;
    }
  };
  return (
    <footer className="py-5" style={{ backgroundColor: "#05162E" }}>
      <div className="container py-4">
        <div className="row g-4">
          <div className="col-lg-4">
            <h5 className="fw-bold mb-3" style={styles.whiteText}>
              Imóveis Mendicino
            </h5>
            <p className="small lh-lg col-md-10" style={styles.mutedText}>
              Do aconchegante ao sofisticado, imóveis selecionados para cada
              momento da sua vida. Encontre a propriedade que reflete seu estilo
              de vida.
            </p>
            <div className="d-flex gap-3 mt-4">
              <button
                onClick={() => handleSocialMediaClick("instagram")}
                rel="noopener noreferrer"
                style={styles.link}
              >
                <i className="fab fa-instagram fs-5"></i>
              </button>
              <button
                onClick={() => handleSocialMediaClick("facebook")}
                rel="noopener noreferrer"
                style={styles.link}
              >
                <i className="fab fa-facebook-f fs-5"></i>
              </button>
              <button
                onClick={() => handleSocialMediaClick("whatsapp")}
                rel="noopener noreferrer"
                style={styles.link}
              >
                <i className="fab fa-whatsapp fs-5"></i>
              </button>
            </div>
          </div>

          <div className="col-6 col-md-3 col-lg-2">
            <h6
              className="fw-bold text-uppercase small mb-3"
              style={{ ...styles.heading, ...styles.whiteText }}
            >
              Imóveis
            </h6>
            <ul className="list-unstyled d-flex flex-column gap-2 small">
              {[
                "Casas",
                "Apartamentos",
                "Lotes",
                "Lojas",
                "Salas",
                "Outros",
              ].map((label) => {
                const href = `/imoveis/${label.toLowerCase()}`;
                return (
                  <li key={label}>
                    <a
                      href={href}
                      style={{ ...styles.link, ...styles.mutedText }}
                    >
                      {label}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>

          <div className="col-6 col-md-3 col-lg-2">
            <h6
              className="fw-bold text-uppercase small mb-3"
              style={{ ...styles.heading, ...styles.whiteText }}
            >
              Links
            </h6>
            <ul className="list-unstyled d-flex flex-column gap-2 small">
              <li>
                <a href="/" style={{ ...styles.link, ...styles.mutedText }}>
                  Home
                </a>
              </li>
            </ul>
          </div>

          <div className="col-md-6 col-lg-4">
            {/* <h6
              className="fw-bold text-uppercase small mb-3"
              style={styles.heading}
            >
              Newsletter
            </h6>
            <p className="small mb-3" style={styles.mutedText}>
              Receba as novidades do mercado de luxo diretamente no seu e-mail.
            </p>
            <div className="input-group">
              <input
                type="email"
                className="form-control border-0 small"
                placeholder="Seu e-mail"
                style={{
                  backgroundColor: "#1E293B",
                  color: "#FFFFFF",
                  opacity: 0.8,
                }}
              />
              <button
                className="btn"
                type="button"
                style={{ backgroundColor: "#2A9D8F", color: "#FFFFFF" }}
              >
                <i className="fas fa-paper-plane"></i>
              </button>
            </div> */}
          </div>
        </div>

        <div
          className="mt-5 pt-4 text-center"
          style={{ borderTop: "1px solid", ...styles.border }}
        >
          <p className="small m-0" style={styles.mutedText}>
            &copy; 2026 Imóveis Mendicino. Todos os direitos reservados.
            CRECI-MG 46059
          </p>
          <p
            className="small m-0 mt-1"
            style={{ ...styles.mutedText, opacity: 0.6 }}
          >
            Tem interesse em ter um site como este?{" "}
            <a
              href="mailto:pedromendicino25@gmail.com"
              style={{ color: "#94A3B8", opacity: 0.8 }}
              className="text-decoration-none"
            >
              Fale com o desenvolvedor: pedromendicino25@gmail.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
